import { createAction, props } from '@ngrx/store';
import { PatientSurgicalHistory } from '../../../models/patient-surgical-history';

export const loadPatientSurgicalHistories = createAction(
  '[Patient Surgical History] Load Patient Surgical Histories',
  props<{ pageNumber: number; pageSizeOverride?: number }>()
);

export const getPatientSurgicalHistoriesSuccess = createAction(
  '[Patient Surgical History] Get Patient Surgical Histories Success',
  props<{
    patientSurgicalHistories: PatientSurgicalHistory[];
    pageNumber: number;
    isAtEndOfData: boolean;
    totalRecordCount: number;
  }>()
);

export const getPatientSurgicalHistoriesFailure = createAction(
  '[Patient Surgical History] Get Patient Surgical Histories Failure',
  props<{ error: unknown }>()
);

export const getAllPatientSurgicalHistories = createAction(
  '[Patient Surgical History] Get All Patient Surgical Histories',
  props<{ patientId: number }>()
);

export const getAllPatientSurgicalHistoriesSuccess = createAction(
  '[Patient Surgical History] Get All Patient Surgical Histories Success',
  props<{ patientSurgicalHistories: PatientSurgicalHistory[]; patientId: number; loadedAt: number }>()
);

export const getAllPatientSurgicalHistoriesFailure = createAction(
  '[Patient Surgical History] Get All Patient Surgical Histories Failure',
  props<{ error: unknown }>()
);

export const invalidateSurgicalHistoryCache = createAction(
  '[Patient Surgical History] Invalidate Surgical History Cache'
);

export const recordPatientSurgicalHistoryPrintEvent = createAction(
  '[Patient Surgical History] Record Print Event',
  props<{ patientId: number; patientSurgeryIds: number[] }>()
);

export const recordPatientSurgicalHistoryPrintEventSuccess = createAction(
  '[Patient Surgical History] Record Print Event Success'
);

export const recordPatientSurgicalHistoryPrintEventFailure = createAction(
  '[Patient Surgical History] Record Print Event Failure',
  props<{ error: unknown }>()
);
